'use strict';
import '../css/site.css';

import * as utils from './utils';

window.DEBUG = utils.getParameter("debug");

import './detection.js';
import './vendor/hyperform.js';

import templates from './templates';
import metrics from './metrics';

import slider from './components/slider';
import forms from './components/forms';

import home from './pages/home';
import contact_us from './pages/contact_us';
import our_services from './pages/our_services';
import about_us from './pages/about_us';
import test from './pages/test';

var siteWeb = function () {
	this.build();
	this.initialize();
};

siteWeb.prototype.build = function () {
	var self = this;
	templates(utils.getLocale(), function () {
		self.bindings();
		metrics();
		forms();
	});
}

siteWeb.prototype.getHash = function (full) {
	var tmp = window.location.hash.split("#")[1];
	if (tmp) {
		if (full) {
			return tmp;
		} else {
			return tmp.split("&")[0];
		}
	}
	return tmp;
};

siteWeb.prototype.getHashParam = function (id) {
	var hash = this.getHash(true),
		params = [],
		returnValue,
		returnObject;

	if (hash) {
		params = hash.split("&");
		if (params.length) {
			if (!id) {
				return params.splice(1, params.length);
			} else {
				params.forEach(function (value, index) {
					// first value is hash! #&param1=foo&param2=bar
					if (index > 0) {
						if (value.split("=")[0] === id) {
							returnValue = value.split("=")[1];
						}
					}
				});
			}
			
		}
	} else {
		returnValue = false;
	}

	return returnValue
};

siteWeb.prototype.setHashParam = function (param) {
	var hash = this.getHash(true), params, tmpObj = {};

	// TODO sin terminar
	/*if (hash && param) {
		params = hash.split("&").splice(1, params.length);// removed hash
		if (params.length) {

			params.forEach(function (value, index) {
				// first value is hash! #&param1=foo&param2=bar
				if (index > 0) {
					if (value.split("=")[0] === id) {
						returnValue = value.split("=")[1];
					}
				}
			});
		}
			
	}*/
};

siteWeb.prototype.clearHashParams = function () {
	var hash = this.getHash();
	if (!hash && history) {
		history.pushState("", document.title, window.location.pathname + window.location.search);
		return;
	} else if (!hash) {
		hash = "";
	}
	window.location.hash = hash;
}

siteWeb.prototype.initialize = function () {
	var self = this, hash, hashParam;

	this.validTemplates = document.querySelector("#validTemplates").value.split(",");

	hash = this.getHash() || "home";
	//hashParam = this.getHashParam();
	this.prevView = Math.random() + "";
	this.loadView(hash);

	// dynamic template loading 
	window.onhashchange = function () {
		self.loadView(self.getHash());
	};
};

siteWeb.prototype.reloadActive = function () {
	var hash, elem, self = this;
	hash = self.getHash();
	elem = document.querySelector(".site-menu li a[href='#" + hash + "']");
	if (hash && elem) {
		elem.classList.add("active");
	}
};

siteWeb.prototype.removeActive = function () {
	var links = document.querySelectorAll(".site-menu li a");
	[].forEach.call(links, function(link) {
		link.classList.remove("active");
	});
};

siteWeb.prototype.bindings = function () {
	var self = this;
	var links = document.querySelectorAll(".site-menu-dropdown a");

	document.querySelector(".site-menu").onclick = function (e) {
		if (e.target.nodeName === "A" && e.target.classList.contains("action-menu-link")) {
			[].forEach.call(document.querySelectorAll(".site-menu-dropdown a"), function(el) {
				el.classList.remove("active");
			});
			e.target.classList.add("active");
		} else {
			if ( e.target.classList.contains("action-menu") || e.target.classList.contains("close-menu") ) {
				// nothing
			} else {
				e.stopPropagation();
			}
		}
	}

	document.querySelector(".close-menu").onclick = function (e) {
		e.preventDefault();
	}	

	document.querySelector(".open-menu").onclick = function (e) {
		e.preventDefault();
		e.stopPropagation();
		document.querySelector("html").classList.add("menu-open");
	}

	document.onclick = function (e) {
		document.querySelector("html").classList.remove("menu-open");
	}

	document.querySelector(".popups-wrapper").onclick = function (e) {
		if (!e.target.classList.contains("popup-close")) {
			e.stopPropagation();
		}
	}

	document.querySelector("#popup-overlay").onclick = function () {
		self.hidePopups();
	}

	window.onsubmit = function () {
		self.showPopup("loading");
	}
}

siteWeb.prototype.loadView = function (the_view) {
	var section, targetView, popup = this.getHashParam("popup");

	// check for popups
	if (popup) {
		this.showPopup(popup);
	}

	if (/*!the_view || */the_view === this.prevView) {
		return;
	}

	//if (!this.validTemplates.includes(the_view)) {
	if (this.validTemplates.indexOf(the_view) === -1) {
		DEBUG && console.error("[APP] Template data not found in JSON file!");
		the_view = "home";
		//return;
	}


	[].forEach.call(document.querySelectorAll("[role='main'] > section"), function(section) {
		section.classList.remove("active");
	});

	targetView = document.querySelector("[role='main'] > section." + the_view);

	if (targetView) {
		targetView.classList.add("active");
	} else {
		targetView = document.createElement('section');
		targetView.classList.add(the_view);
		targetView.classList.add("active");
		targetView.innerHTML = document.querySelector("#template-" + the_view).innerHTML;

		document.querySelector("[role='main']").appendChild(targetView);
		//document.querySelector("#template-" + the_view).remove();
	}

	// helper para css mas que nada
	document.querySelector("body").setAttribute("data-page", the_view);
	this.onChangeView(the_view);
	this.prevView = the_view;
	this.removeActive();
	this.reloadActive();
};

siteWeb.prototype.showPopup = function (id) {
	var elem = document.querySelector("#popup-" + id);

	if (!id || !elem) {
		return;
	}

	document.querySelector(".popup-overlay").classList.add("active");
	[].forEach.call(document.querySelectorAll(".site-popup"), function(popup) {
		popup.classList.remove("active");
	});
	
	elem.classList.add("active");
};

siteWeb.prototype.hidePopups = function () {
	[].forEach.call(document.querySelectorAll(".site-popup"), function(popup) {
		popup.classList.remove("active");
	});

	this.clearHashParams();
	document.querySelector(".popup-overlay").classList.remove("active");
};

siteWeb.prototype.onChangeView = function (the_view) {
	window.scrollTo(0, 0);

	// apply slider all views
	slider(document.querySelectorAll(".slider"), {
		timer: 4000,
		speed: 900
	});

	if (the_view === "home") {
		home(this.getHashParam("action"));
	} else if (the_view === "contact_us") {
		contact_us(this.getHashParam("action"));
	} else if (the_view === "our_services") {
		our_services(this.getHashParam("action"));
	} else if (the_view === "about_us") {
		about_us(this.getHashParam("action"));
	}

	this.clearHashParams();
};

new siteWeb;


//////////////////
// WEBPACK FOOTER
// ./src/js/site.js
// module id = 55
// module chunks = 0